import React from "react";

export function TrunkDivider() {
  return (
    <div className="trunk-divider">
      <svg viewBox="0 0 1200 60" preserveAspectRatio="none">
        <path d="M0 30 Q 300 0 600 30 T 1200 30" fill="none" stroke="#B76E79" strokeWidth="1" opacity="0.35" />
      </svg>
    </div>
  );
}

export function Hero() {
  return (
    <section className="hero" id="home">
      <img className="hero-bg-ele" src="/assets/logo.png" alt="" />
      <div className="wrap">
        <div className="hero-grid">
          <div className="hero-copy">
            <div className="hero-eyebrow">
              <span className="dot"></span>
              <span className="eyebrow">Senior Placement &amp; Advocacy · South Florida to Orlando</span>
            </div>
            <h1 className="headline">Helping families find the right senior care, <em>with confidence.</em></h1>
            <p className="lede">From the first conversation to long after placement, we're your advocate. We listen, assess, and match your loved one with the environment that fits their wellness, care, and lifestyle needs.</p>
            <div className="hero-actions">
              <a className="btn" href="tel:9547080298">Call 954-708-0298</a>
              <a className="btn btn-outline" href="mailto:care@askhemo.com">Email Care Team</a>
            </div>
            <div className="trust-row">
              <div className="trust-item"><b>20+ yrs</b><span>Local placement experience</span></div>
              <div className="trust-item"><b>5</b><span>Care pathways guided</span></div>
              <div className="trust-item"><b>$0</b><span>Cost to families</span></div>
            </div>
          </div>
          <div className="hero-photo-wrap">
            <div className="hero-photo-frame">
              <img src="/assets/hero.jpg" alt="Senior couple reviewing retirement and care plans with an advisor" loading="eager" />
            </div>
            <div className="hero-photo-tag">
              <b>20+ Years</b>
              <span>Trusted Local Care</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function About() {
  return (
    <section className="about" id="about">
      <div className="wrap">
        <div className="about-grid">
          <div className="about-photo-wrap">
            <div className="about-photo-frame">
              <img src="/assets/about.jpg" alt="Hemo with a beloved family member, reflecting the compassionate care she brings to every family" />
            </div>
          </div>
          <div className="about-copy">
            <span className="eyebrow">About Us</span>
            <h2>Meet Hemo, your local advocate.</h2>
            <p className="lede">Hemo built Compassionate Senior Placement on a simple idea: families deserve an advocate, not a sales pitch. With over 20 years of local experience serving South Florida to Orlando, she has walked alongside hundreds of families through one of the hardest decisions they'll ever make &mdash; and turned it into one of the most reassuring.</p>
            <p className="lede">Every recommendation is built around your loved one's wellness, care, and lifestyle needs, never a facility's bottom line. From the first phone call to long after placement, Hemo stays in your corner.</p>
            <div className="about-badges">
              <div className="about-badge"><b>20+</b><span>Years local experience</span></div>
              <div className="about-badge"><b>1:1</b><span>Personal consultations</span></div>
              <div className="about-badge"><b>$0</b><span>Cost to families</span></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const services = [
  {
    num: "01",
    title: "Personalized Consultations",
    text: "We listen, understand, and recommend the right options for your family.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><circle cx="8" cy="8" r="3" /><circle cx="16" cy="8" r="3" /><path d="M2 20c0-3 2.5-5 6-5s6 2 6 5M10 20c0-3 2.5-5 6-5s6 2 6 5" /></svg>
    ),
  },
  {
    num: "02",
    title: "Care Options Guidance",
    text: "Independent living, assisted living, memory care, in-home care, and more.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M3 11 12 4l9 7M5 10v10h14V10" /></svg>
    ),
  },
  {
    num: "03",
    title: "Care Needs Assessments",
    text: "We evaluate needs and preferences to find the best possible fit.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><rect x="5" y="4" width="14" height="17" rx="1.5" /><path d="M9 3h6v3H9zM8 10h8M8 14h8M8 18h5" /></svg>
    ),
  },
  {
    num: "04",
    title: "Family Support",
    text: "We're your advocate, providing support and clarity every step of the way.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><circle cx="7" cy="8" r="3" /><circle cx="17" cy="8" r="3" /><path d="M1 20c0-3 2.7-5 6-5s6 2 6 5M11 20c0-3 2.7-5 6-5s6 2 6 5" /></svg>
    ),
  },
  {
    num: "05",
    title: "Ongoing Advocacy",
    text: "Our commitment continues long after the decision is made.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M12 21s-7.5-4.6-10-9.2C.5 8.4 2.4 5 6 5c2 0 3.6 1.2 4.5 2.6M12 21s7.5-4.6 10-9.2C23.5 8.4 21.6 5 18 5c-2 0-3.6 1.2-4.5 2.6" /><path d="M9 7l3 4 3-4" /></svg>
    ),
  },
];

export function Services() {
  return (
    <section className="services" id="services">
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow">Our Services</span>
          <h2>Every step, guided — from the first call to long after placement.</h2>
          <p>Care Options Guidance, Care Needs Assessments, Family Support, Ongoing Advocacy &mdash; we cover the whole journey so you don't have to navigate it alone.</p>
        </div>
        <div className="service-grid">
          {services.map((s) => (
            <div className="service-card" key={s.num}>
              <span className="service-num">{s.num}</span>
              <div className="service-icon">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function Expertise() {
  return (
    <section className="expertise">
      <div className="wrap">
        <div className="expertise-card">
          <img className="expertise-deco" src="/assets/logo.png" alt="" />
          <div className="expertise-left">
            <span className="eyebrow">Local Expertise</span>
            <h3>Serving South Florida to Orlando, with over 20 years of local experience.</h3>
            <p>Local roots. Personal touch. Trusted guidance. We know the communities, the providers, and the details that make a placement feel like the right home.</p>
          </div>
          <div className="expertise-right">
            <span>More options.</span>
            <span>More support.</span>
            <span>More peace of mind.</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export function FeaturedQuote() {
  return (
    <section className="testimonial">
      <div className="wrap">
        <span className="mark">&ldquo;</span>
        <blockquote>The greatest compliment I can receive is a referral to your friends and family.</blockquote>
        <cite>— Hemo, Owner, Compassionate Senior Placement LLC</cite>
      </div>
    </section>
  );
}

const testimonials = [
  {
    quotes: [
      "Hemo is trustworthy, knowledgeable, and truly understands the senior living industry. She takes the time to listen, gets to know each family's needs, and helps find the right community with care and compassion.",
      "I've referred many clients to Hemo and have always felt confident they're in good hands. If you're looking for someone who genuinely cares and knows the industry, I can't recommend her enough.",
    ],
    img: "/assets/testimonial.jpg",
    name: "Musi",
    role: "Trusted Referral Partner",
  },
  {
    quotes: [
      "Working with Compassionate Senior Placement was truly a blessing during what could have been an incredibly stressful and overwhelming time for our family. From our very first conversation, Hemo treated us with genuine compassion, patience, and understanding.",
      "I would wholeheartedly recommend Hemo and Compassionate Senior Placement to any family looking for senior living or memory care guidance. Her compassion, knowledge, and dedication are exactly what families need during such an important transition.",
    ],
    img: "/assets/testimonial-amanda.jpg",
    name: "Dr. Amanda Persaud, MD",
    role: "Neurologist",
  },
  {
    quotes: [
      "I have known Hemo Sahadeo for many years and have always found her to be trustworthy, deeply compassionate, and completely dependable. She approaches every task with genuine care and strong work ethics. She is knowledgeable, and understands well the senior living industry.",
      "Working with her is an absolute pleasure because she listens closely to what you want, respects your timeline, and knows the local market inside and out.",
    ],
    img: "/assets/testimonial-chandra.jpg",
    name: "Chandra Singh",
    role: "Community Reference",
  },
];

export function Testimonials() {
  return (
    <section className="testimonials" id="testimonials">
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow">Testimonials</span>
          <h2>What people are saying.</h2>
        </div>
        <div className="testimonial-grid">
          {testimonials.map((t) => (
            <div className="testimonial-card" key={t.name}>
              <span className="testimonial-quote-mark">&ldquo;</span>
              {t.quotes.map((q, i) => (
                <p className="testimonial-text" key={i}>{q}</p>
              ))}
              <div className="testimonial-author">
                <img src={t.img} alt={t.name} />
                <div>
                  <b>{t.name}</b>
                  <span>{t.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
